/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistCosoAmbitoDTO} from './ChecklistCosoAmbitoDTO';

/**
 * The ChecklistCosoRequisitoDTO model module.
 * @module model/ChecklistCosoRequisitoDTO
 * @version v0
 */
export class ChecklistCosoRequisitoDTO {
  /**
   * Constructs a new <code>ChecklistCosoRequisitoDTO</code>.
   * @alias module:model/ChecklistCosoRequisitoDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistCosoRequisitoDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistCosoRequisitoDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistCosoRequisitoDTO} The populated <code>ChecklistCosoRequisitoDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistCosoRequisitoDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('checklistCosoAmbiti'))
        obj.checklistCosoAmbiti = ApiClient.convertToType(data['checklistCosoAmbiti'], [ChecklistCosoAmbitoDTO]);
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistCosoRequisitoDTO.prototype.id = undefined;

/**
 * @member {Number} position
 */
ChecklistCosoRequisitoDTO.prototype.position = undefined;

/**
 * @member {String} title
 */
ChecklistCosoRequisitoDTO.prototype.title = undefined;

/**
 * @member {Array.<module:model/ChecklistCosoAmbitoDTO>} checklistCosoAmbiti
 */
ChecklistCosoRequisitoDTO.prototype.checklistCosoAmbiti = undefined;

/**
 * @member {String} tooltip
 */
ChecklistCosoRequisitoDTO.prototype.tooltip = undefined;

